import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { AppComponent } from 'src/app/app.component';

@Component({
    selector: 'app-update-contact',
    templateUrl: './update-contact.component.html',
    styleUrls: ['./update-contact.component.scss'],
    standalone: false
})
export class UpdateContactComponent implements OnInit {
 title = 'Select Contact';
contactMode: any
data:any
contactData:any[]=[]
  translate: any;
  addContactForm!: UntypedFormGroup;

  constructor(
    public modalRef : BsModalRef,
         private globalJOServc: GlobalJobordersService,
         private spinner: NgxSpinnerService,
         private errorUtil: ErrorUtil,
         private util: UtilServiceService,
  ) { 
   this.addContactForm = new UntypedFormGroup({
          name: new UntypedFormControl(null, [Validators.required]),
          phone: new UntypedFormControl(null, [
            Validators.required,
            Validators.pattern(AppComponent.phonePattern),
          ]),
          email: new UntypedFormControl(null, [
            Validators.required,
            Validators.pattern(AppComponent.emailPattern),
          ]),
         });
         
  }

  ngOnInit(): void {
  
      console.log("data in update location modal", this.data);
      this.translate = this.data.translate
  
       this.getLocation()
     
    }
  
  /********************  Initialize Google Autocomplete Lisner *****************/
   
  
    // actions
  /********************  Go to create location mode *****************/
    goCreate() { 
       this.title = this.translate?.general.buttons.new.singular +' '+ this.translate?.contacts.label.singular;
      this.contactMode = 'createWithSearch';
     
      
     }
  /********************  Go back to select location mode *****************/
    goBack() {  this.title = this.translate?.general.buttons.select2.singular +' '+ this.translate?.contacts.label.singular; this.contactMode = 'select'; }
  /********************  Fetch location based on customer/site/asset/project *****************/
  
  getLocation() {
    if(this.data.customer.id || this.data.site.id  || this.data.project.id){
      this.contactData = [];
      var contactData: any[] = [];
      this.contactMode = 'select';
      this.globalJOServc.getJobOrderContactBaseOnCustomerSiteAssetProject(
        this.data.customer.id ? this.data.customer.id : 0,
        this.data.site.id ? this.data.site.id : 0,
        this.data.project.id ? this.data.project.id : 0,
      ).subscribe((res: any) => {
         // console.log("location response", res);
          if(res && res.body){
            //this.contactData = res.body;
            res.body.forEach((loc: any) => {
              
              var newObj = {
                valueName: loc.customerId ? 'Customer' : loc.siteId ? 'Site' :'Project',
                modelFieldList: [loc]

              }
               console.log("location data after title", newObj);
               if(loc.contactPersonName){
               contactData.push(newObj);
              }
  
            })
           
            if(contactData.length == 0){
              this.contactMode = 'createWithSearch';
            } else {
              this.contactData = [...contactData];
            }
          }
        },
        (err: any) =>{
          console.log(err, 'error in GET location api')
          this.errorUtil.setErrorMessage(err.status,err.error ? err.error.title : null,err.error ? err.error.title : null,"error",3000);
        });
    }else{
      this.title = this.translate?.general.buttons.new.singular +' '+ this.translate?.contacts.label.singular;
      this.contactMode = 'create';
    }
  
  }
 
    updateContact() {
     if (this.addContactForm.invalid) {
        this.addContactForm.markAllAsTouched();
        return;
      }
      this.data.contactPersonName = this.addContactForm.value.name;
      this.data.contactPersonEmail = this.addContactForm.value.email;
      this.data.contactPersonPhone = this.addContactForm.value.phone;
      console.log("updated location data", this.data);
      this.globalJOServc.setJOContactData(this.data);
      this.modalRef.hide();
    }
    selectContact(event: any) {
      console.log("selected location", event);
      if(!event || !event.value){
        return;
      }
      this.globalJOServc.setJOContactData(event.value);
      this.modalRef.hide();
    }

}
